/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProcessUploadedTravelCostRequestUploadedDataInner model module.
 * @module model/ProcessUploadedTravelCostRequestUploadedDataInner
 * @version 0.0.2
 */
class ProcessUploadedTravelCostRequestUploadedDataInner {
    /**
     * Constructs a new <code>ProcessUploadedTravelCostRequestUploadedDataInner</code>.
     * @alias module:model/ProcessUploadedTravelCostRequestUploadedDataInner
     */
    constructor() { 
        
        ProcessUploadedTravelCostRequestUploadedDataInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProcessUploadedTravelCostRequestUploadedDataInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProcessUploadedTravelCostRequestUploadedDataInner} obj Optional instance to populate.
     * @return {module:model/ProcessUploadedTravelCostRequestUploadedDataInner} The populated <code>ProcessUploadedTravelCostRequestUploadedDataInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProcessUploadedTravelCostRequestUploadedDataInner();

            if (data.hasOwnProperty('fromLocationName')) {
                obj['fromLocationName'] = ApiClient.convertToType(data['fromLocationName'], 'String');
            }
            if (data.hasOwnProperty('toLocationName')) {
                obj['toLocationName'] = ApiClient.convertToType(data['toLocationName'], 'String');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'String');
            }
            if (data.hasOwnProperty('duration')) {
                obj['duration'] = ApiClient.convertToType(data['duration'], 'Number');
            }
            if (data.hasOwnProperty('distance')) {
                obj['distance'] = ApiClient.convertToType(data['distance'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProcessUploadedTravelCostRequestUploadedDataInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProcessUploadedTravelCostRequestUploadedDataInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['fromLocationName'] && !(typeof data['fromLocationName'] === 'string' || data['fromLocationName'] instanceof String)) {
            throw new Error("Expected the field `fromLocationName` to be a primitive type in the JSON string but got " + data['fromLocationName']);
        }
        // ensure the json data is a string
        if (data['toLocationName'] && !(typeof data['toLocationName'] === 'string' || data['toLocationName'] instanceof String)) {
            throw new Error("Expected the field `toLocationName` to be a primitive type in the JSON string but got " + data['toLocationName']);
        }
        // ensure the json data is a string
        if (data['vehicleType'] && !(typeof data['vehicleType'] === 'string' || data['vehicleType'] instanceof String)) {
            throw new Error("Expected the field `vehicleType` to be a primitive type in the JSON string but got " + data['vehicleType']);
        }

        return true;
    }


}



/**
 * The name of the origin location for this travel cost. This should match a location in the Locations array.
 * @member {String} fromLocationName
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['fromLocationName'] = undefined;

/**
 * The name of the destination location for this travel cost. This should match a location in the Locations array.
 * @member {String} toLocationName
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['toLocationName'] = undefined;

/**
 * The name of the vehicle type for this travel cost. This should match a vehicle type in the VehicleTypes array. If not provided, the travel cost will apply to all vehicle types.
 * @member {String} vehicleType
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['vehicleType'] = undefined;

/**
 * The travel duration between these two locations, in seconds.
 * @member {Number} duration
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['duration'] = undefined;

/**
 * The travel distance between these two locations, in kilometers.
 * @member {Number} distance
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['distance'] = undefined;

/**
 * The cost of travel between these two locations.
 * @member {Number} cost
 */
ProcessUploadedTravelCostRequestUploadedDataInner.prototype['cost'] = undefined;






export default ProcessUploadedTravelCostRequestUploadedDataInner;

